<script>
    import CreateAccount from '/public/components/users/CreateAccount.svelte';
</script>

<main>
    <div class="row justify-content-center mt-3 mb-3">
        <div class="col-sm-10 col-md-6 col-lg-4">
            <CreateAccount/>
        </div>
    </div>
</main>
